import { useState, useEffect, useRef } from 'react';
import { IntersectionObserver } from 'client/utils/intersection-observer';

export function useStickyIntersection(targetRef, rootRef) {
  const [isSticky, setIsSticky] = useState(false);
  const observer = useRef();

  useEffect(() => {
    if (!IntersectionObserver || !(targetRef?.current && rootRef?.current)) {
      return undefined;
    }

    observer.current = new IntersectionObserver(
      ([entry]) => {
        const sticky = !entry.isIntersecting && entry.boundingClientRect.top < entry.rootBounds.top;
        setIsSticky(sticky);
      },
      { root: rootRef.current }
    );

    observer.current.observe(targetRef.current);

    return () => {
      observer.current.disconnect();
      observer.current = null;
      setIsSticky(false);
    };
  }, [targetRef, rootRef]);

  return isSticky;
}
